'use client';

import { SearchDrawer } from '@eliadmin/core/src/components/header/search-bar/search-drawer';
import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiSearch } from 'react-icons/fi';

// Brand-specific trigger only. Dialog, queries, pricing and result rendering live in core.
export type SearchButtonProps = Omit<ButtonProps, 'onClick' | 'className'> & {
  className?: {
    root?: string;
    icon?: string;
  };
};

export function SearchButton(props: SearchButtonProps) {
  const { className, ...buttonProps } = props;
  return (
    <SearchDrawer
      trigger={
        <Button
          type="button"
          {...buttonProps}
          variant={buttonProps?.variant ? buttonProps.variant : 'outline'}
          className={cn('ea-search-button', className?.root)}
          size={buttonProps?.size ? buttonProps.size : 'icon'}
          aria-label="Search"
        >
          <FiSearch className={cn('h-5 w-5', 'ea-search-button__icon', className?.icon)} />
        </Button>
      }
    />
  );
}
